import React, { useState } from "react";
import { Check } from "lucide-react";

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const REASONS = [
  ["too_many", "Too many emails"],
  ["not_relevant", "Not relevant to me"],
  ["check_portal", "I'll check the portal myself"],
  ["never_signed_up", "I never signed up"],
  ["other", "Other"],
];

export const UnsubscribeReason = ({ token }) => {
  const [picked, setPicked] = useState("");
  const [note, setNote] = useState("");
  const [sent, setSent] = useState(false);

  const send = async (reason, text = "") => {
    const r = await fetch(`${API}/api/email/unsubscribe/reason?t=${encodeURIComponent(token)}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ reason, note: text }),
    });
    if (r.ok) setSent(true);
  };

  const tap = (key) => { setPicked(key); if (key !== "other") send(key); };

  if (sent) {
    return (
      <p className="text-sm text-emerald-800 flex items-center gap-2" data-testid="unsubscribe-reason-thanks">
        <Check className="w-4 h-4" /> Thank you, that helps BTC improve.
      </p>
    );
  }
  return (
    <div className="space-y-3" data-testid="unsubscribe-reason">
      <div className="text-sm font-semibold text-slate-900">Why are you leaving? <span className="font-normal text-slate-500">(optional)</span></div>
      <div className="flex flex-wrap gap-2">
        {REASONS.map(([key, label]) => (
          <button key={key} type="button" onClick={() => tap(key)} data-testid={`unsubscribe-reason-${key}`}
            className={`px-3 py-1.5 rounded-full border text-sm transition-colors ${picked === key ? "bg-[#0B132B] text-white border-[#0B132B]" : "bg-white text-slate-700 hover:bg-slate-50"}`}>
            {label}
          </button>
        ))}
      </div>
      {picked === "other" && (
        <div className="space-y-2">
          <textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={500} rows={3}
            placeholder="Tell us more (optional)" data-testid="unsubscribe-reason-note"
            className="w-full rounded-lg border border-slate-200 p-3 text-sm" />
          <button type="button" onClick={() => send("other", note)} className="btc-btn-outline"
            data-testid="unsubscribe-reason-submit">Send</button>
        </div>
      )}
    </div>
  );
};
